// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bJ-z","smallCardRow":"cJ-z","largeCardRow":"dJ-z","productSearchRow":"eJ-z","curatedRow":"fJ-z"};